import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Col, Container, Row, CardText } from "reactstrap";
import { useTranslation } from "react-i18next";
import "./style.scss";
import ScrollToTop from "../ScrollToTop";

const NAV_SPACE = { paddingTop: 160 };

const SkeletonComponent = {
	Default: () => {
		return <div style={{ height: "80vh", width: "100%", ...NAV_SPACE }}></div>;
	},
	Banner: () => {
		return <Skeleton height={550} width={`100%`} />;
	},
	CompoundDetails: (props) => {
		const { t } = useTranslation();
		return (
			<Container fluid className="px-lg-5 px-3 pb-5 pt-10rem websitPages">
				<ScrollToTop />
				<p
					className="page-title"
					dangerouslySetInnerHTML={{
						__html: t("compound details title"),
					}}></p>
				<Row>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={130}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={200} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={200}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={130} width={`100%`} />
					</Col>
				</Row>
				<Row>
					<h2 className="text-primary mt-4">{t("matching units")}</h2>
					<Row>
						{Array(4)
							.fill()
							.map((item, index) => (
								<Col lg={3} md={5} sm={6} key={index} className="mb-2">
									<SkeletonTheme>
										<Skeleton height={180} className="mb-1" />
										<h2>
											<Skeleton height={36} width={`100%`} />
										</h2>
										<h5>
											<Skeleton height={36} width={`60%`} />
										</h5>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`20%`}
											height={25}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`20%`}
											height={25}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`20%`}
											height={25}
										/>
										<br />
										<Skeleton className="mx-1" width={`100%`} height={25} />
										<br />
										<Skeleton
											inline={true}
											className="mx-1"
											width={`30%`}
											height={40}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`30%`}
											height={40}
										/>
										<Skeleton
											inline={true}
											className="mx-1"
											width={`30%`}
											height={40}
										/>
									</SkeletonTheme>
								</Col>
							))}
					</Row>
					<Col md={12} className="mx-1 mt-4">
						<h2 className="text-primary mt-4">{t("interactive mode")}</h2>
						<Skeleton height={500} width={`100%`} />
					</Col>
					<Col md={12} className="mx-1 mt-4">
						<h2 className="text-primary mt-4">{t("location")}</h2>
						<Skeleton height={500} width={`100%`} />
					</Col>
				</Row>
			</Container>
		);
	},
	ProprtyDetails: (props) => {
		const { t } = useTranslation();

		return (
			<Container fluid className="px-lg-5 px-3 pb-5 pt-10rem websitPages">
				<ScrollToTop />
				<p
					className="page-title"
					dangerouslySetInnerHTML={{
						__html: t("Property Details"),
					}}></p>
				<Row>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={130}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={200} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton height={350} width={`100%`} />
					</Col>
					<Col md={3}>
						<Skeleton
							height={200}
							width={`100%`}
							style={{ marginBottom: "15px" }}
						/>
						<Skeleton height={130} width={`100%`} />
					</Col>
				</Row>
			</Container>
		);
	},
	ProprtyBuyDetails: (props) => {
		const { t } = useTranslation();

		return (
			<Container fluid className="websitPages pt-10rem px-lg-5 px-3 pb-5">
				<ScrollToTop />
				<p
					className="font-size-32 text-primary"
					dangerouslySetInnerHTML={{
						__html: t("Property Process"),
					}}></p>
				<Row>
					<SkeletonTheme>
						<Col md={12}>
							<Skeleton height={150} className="mb-1" />
						</Col>
						<Col md={6} className="mt-3">
							<Skeleton height={100} className="mb-3" />
						</Col>
						<Col md={6} className="mt-3">
							<Skeleton height={100} className="mb-3" />
						</Col>
					</SkeletonTheme>
				</Row>
			</Container>
		);
	},
	ResaleDetails: (props) => {
		const { t } = useTranslation();

		return (
			<Container fluid className="px-lg-5 px-3 pb-5 pt-10rem websitPages">
				<ScrollToTop />
				<p
					className="page-title"
					dangerouslySetInnerHTML={{
						__html: t("Resale Details"),
					}}></p>
				<Row>
					<SkeletonTheme>
						<Col md={3}>
							<Skeleton height={350} className="mb-1" />
						</Col>
						<Col md={3}>
							<Row>
								{" "}
								<Skeleton height={170} className="mb-3" />
							</Row>
							<Row>
								{" "}
								<Skeleton height={160} className="mb-1" />
							</Row>
						</Col>
						<Col md={3}>
							<Skeleton height={350} className="mb-1" />
						</Col>
						<Col md={3}>
							<Row>
								{" "}
								<Skeleton height={170} className="mb-3" />
							</Row>
							<Row>
								{" "}
								<Skeleton height={160} className="mb-1" />
							</Row>
						</Col>
						<Row className=" p-0 d-flex justify-content-between">
							<Col md={8} className="my-2 mx-3">
								<Skeleton inline={true} width={`20%`} height={30} />
								<h2 className="my-4">
									<Skeleton height={36} width={`70%`} />
								</h2>
								<Skeleton inline={true} width={`50%`} height={30} />
							</Col>
							<Col md={3} className="my-2  p-0">
								<Skeleton inline={true} width={`100%`} height={100} />
							</Col>
							<Col md={8}></Col>
							<Col md={4}></Col>
							<Col md={12} className="mx-1">
								<h2
									className="text-primary"
									dangerouslySetInnerHTML={{
										__html: t("property amenities"),
									}}></h2>
								<Skeleton height={200} width={`100%`} />
							</Col>
							<Col md={12} className="mx-1">
								<h2 className="text-primary">{t("payment plans")}</h2>
								<Skeleton height={300} width={`100%`} />
							</Col>
							<Col md={12} className="mx-1">
								<h2 className="text-primary">{t("location")}</h2>
								<Skeleton height={500} width={`100%`} />
							</Col>
						</Row>
					</SkeletonTheme>
				</Row>
			</Container>
		);
	},
	HomeResales: () => {
		return (
			<>
				<ScrollToTop />
				{Array(4)
					.fill()
					.map((item, index) => (
						<Col lg={3} md={5} sm={6} key={index} className="mb-2">
							<SkeletonTheme>
								<Skeleton height={180} className="mb-1" />
								<h2>
									<Skeleton height={36} width={`100%`} />
								</h2>
								<h5>
									<Skeleton height={36} width={`60%`} />
								</h5>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={25}
								/>
								<br />
								<Skeleton className="mx-1" width={`100%`} height={25} />
								<br />
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`30%`}
									height={40}
								/>
							</SkeletonTheme>
						</Col>
					))}
			</>
		);
	},
	Search: () => {
		return <Skeleton height={80} className="mb-5" />;
	},
	Role: () => {
		return (
			<>
				<Skeleton height={177} />
				<Skeleton height={350} />
				<Skeleton height={80} />
			</>
		);
	},
	Compounds: () => {
		return (
			<Row>
				<ScrollToTop />
				<Skeleton height={80} className="mb-5" />
				{Array(9)
					.fill()
					.map((item, index) => (
						<Col lg={4} md={6} sm={6} className="mb-5" key={index}>
							<SkeletonTheme>
								<Skeleton height={180} className="mb-1" />
								<h2>
									<Skeleton height={36} width={`70%`} />
								</h2>
								<Skeleton width={`65%`} height={30} />
								<br />
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
								<Skeleton
									inline={true}
									className="mx-1"
									width={`20%`}
									height={30}
								/>
							</SkeletonTheme>
						</Col>
					))}
			</Row>
		);
	},
	CardImage: () => {
		return (
			<Row>
				{Array(3)
					.fill()
					.map((_, index) => (
						<Col lg={4} md={4} sm={6} key={index}>
							<SkeletonTheme>
								<Skeleton height={350} className="mb-1" />
							</SkeletonTheme>
						</Col>
					))}
			</Row>
		);
	},
	Settings: () => {
		return (
			<>
				<Skeleton height="20rem" className="mt-3" />
			</>
		);
	},
	Table: () => {
		return (
			<>
				<Skeleton height="12rem" className="mt-3 mb-3" />
			</>
		);
	},
	Page: () => {
		return (
			<SkeletonTheme baseColor="#141920" highlightColor="#1e2a36">
				<div
					style={{
						minHeight: "100vh",
						background: "linear-gradient(180deg, #17121c 0%, #28102a 100%)",
					}}>
					<Skeleton
						height={520}
						width="100%"
						style={{ display: "block", borderRadius: 0 }}
					/>
					<div
						style={{ maxWidth: 1200, margin: "0 auto", padding: "40px 20px" }}>
						<Skeleton height={32} width={180} style={{ marginBottom: 32 }} />
						<Row>
							{Array(3)
								.fill()
								.map((_, i) => (
									<Col key={i} lg={4} md={4} sm={6} className="mb-4">
										<Skeleton height={300} style={{ borderRadius: 12 }} />
										<Skeleton height={22} width="75%" className="mt-2" />
										<Skeleton height={18} width="50%" className="mt-1" />
									</Col>
								))}
						</Row>
					</div>
				</div>
			</SkeletonTheme>
		);
	},

	// ── Website page skeletons ────────────────────────────────────────────────

	HomePage: () => (
		<SkeletonTheme>
			<div>
				{/* Hero banner */}
				<Skeleton
					height={580}
					width="100%"
					style={{ display: "block", borderRadius: 0 }}
				/>
				{/* Games section */}
				<div
					className="container"
					style={{ paddingTop: 48, paddingBottom: 48 }}>
					<Skeleton height={36} width={160} style={{ marginBottom: 24 }} />
					<Skeleton height={28} width={220} style={{ marginBottom: 24 }} />
					<Row>
						{Array(3)
							.fill()
							.map((_, i) => (
								<Col key={i} lg={4} md={4} sm={6} className="mb-4">
									<Skeleton height={260} style={{ borderRadius: 12 }} />
									<Skeleton height={20} width="70%" className="mt-2" />
									<Skeleton height={16} width="45%" className="mt-1" />
									<Skeleton
										height={40}
										width="100%"
										className="mt-2"
										style={{ borderRadius: 8 }}
									/>
								</Col>
							))}
					</Row>
				</div>
			</div>
		</SkeletonTheme>
	),

	GamesSection: () => (
		<SkeletonTheme>
			<Row>
				{Array(3)
					.fill()
					.map((_, i) => (
						<Col key={i} lg={4} md={4} sm={6} className="mb-4">
							<Skeleton height={260} style={{ borderRadius: 12 }} />
							<Skeleton height={20} width="70%" className="mt-2" />
							<Skeleton height={16} width="45%" className="mt-1" />
							<Skeleton
								height={40}
								width="100%"
								className="mt-2"
								style={{ borderRadius: 8 }}
							/>
						</Col>
					))}
			</Row>
		</SkeletonTheme>
	),

	GamesPage: () => (
		<SkeletonTheme>
			<div>
				<Row>
					{Array(6)
						.fill()
						.map((_, i) => (
							<Col key={i} lg={4} md={4} sm={6} className="mb-4">
								<Skeleton height={260} style={{ borderRadius: 12 }} />
								<Skeleton height={20} width="70%" className="mt-2" />
								<Skeleton height={16} width="45%" className="mt-1" />
								<Skeleton
									height={40}
									width="100%"
									className="mt-2"
									style={{ borderRadius: 8 }}
								/>
							</Col>
						))}
				</Row>
			</div>
		</SkeletonTheme>
	),

	GameDetailsPage: () => (
		<SkeletonTheme>
			<div>
				<div className="container" style={NAV_SPACE}>
					{/* Breadcrumb */}
					<Skeleton height={18} width={240} style={{ marginBottom: 24 }} />
					<Row className="mb-5">
						{/* Image */}
						<Col md={6} className="mb-4">
							<Skeleton height={400} style={{ borderRadius: 12 }} />
						</Col>
						{/* Details */}
						<Col md={6}>
							<Skeleton height={36} width="80%" style={{ marginBottom: 16 }} />
							<div className="d-flex gap-8 mb-4">
								{Array(3)
									.fill()
									.map((_, i) => (
										<Skeleton
											key={i}
											height={28}
											width={80}
											style={{ borderRadius: 20 }}
										/>
									))}
							</div>
							<Skeleton height={18} width="40%" style={{ marginBottom: 12 }} />
							<Skeleton height={16} count={4} style={{ marginBottom: 8 }} />
							<Skeleton
								height={48}
								width="50%"
								style={{ borderRadius: 10, marginTop: 24 }}
							/>
						</Col>
					</Row>
					{/* Other games */}
					<Skeleton height={28} width={200} style={{ marginBottom: 20 }} />
					<Row>
						{Array(3)
							.fill()
							.map((_, i) => (
								<Col key={i} lg={4} md={4} sm={6} className="mb-4">
									<Skeleton height={220} style={{ borderRadius: 12 }} />
									<Skeleton height={18} width="70%" className="mt-2" />
								</Col>
							))}
					</Row>
				</div>
			</div>
		</SkeletonTheme>
	),

	BookingPage: () => (
		<SkeletonTheme>
			<div>
				<div className="container" style={NAV_SPACE}>
					<Skeleton height={18} width={260} style={{ marginBottom: 28 }} />
					<Row>
						{/* Calendar side */}
						<Col md={7} className="mb-4">
							<Skeleton height={380} style={{ borderRadius: 12 }} />
							<Row className="mt-3">
								{Array(6)
									.fill()
									.map((_, i) => (
										<Col key={i} xs={6} sm={4} className="mb-2">
											<Skeleton height={50} style={{ borderRadius: 8 }} />
										</Col>
									))}
							</Row>
						</Col>
						{/* Summary side */}
						<Col md={5}>
							<Skeleton
								height={60}
								style={{ borderRadius: 10, marginBottom: 12 }}
							/>
							<Skeleton
								height={60}
								style={{ borderRadius: 10, marginBottom: 12 }}
							/>
							<Skeleton
								height={120}
								style={{ borderRadius: 10, marginBottom: 16 }}
							/>
							<Skeleton height={50} width="100%" style={{ borderRadius: 10 }} />
						</Col>
					</Row>
				</div>
			</div>
		</SkeletonTheme>
	),

	MyBookingsPage: () => (
		<SkeletonTheme>
			<div>
				<div className="container" style={NAV_SPACE}>
					<Skeleton height={32} width={200} style={{ marginBottom: 8 }} />
					<Skeleton height={18} width={280} style={{ marginBottom: 28 }} />
					{/* Tabs */}
					<div className="d-flex gap-8 mb-4">
						{Array(4)
							.fill()
							.map((_, i) => (
								<Skeleton
									key={i}
									height={40}
									width={100}
									style={{ borderRadius: 20 }}
								/>
							))}
					</div>
					{/* Booking rows */}
					{Array(3)
						.fill()
						.map((_, i) => (
							<div
								key={i}
								className="d-flex gap-8 mb-3"
								style={{
									background: "#141920",
									borderRadius: 12,
									padding: 16,
								}}>
								<Skeleton
									height={100}
									width={130}
									style={{ borderRadius: 8, flexShrink: 0 }}
								/>
								<div style={{ flex: 1 }}>
									<Skeleton
										height={20}
										width="55%"
										style={{ marginBottom: 8 }}
									/>
									<Skeleton
										height={16}
										width="35%"
										style={{ marginBottom: 16 }}
									/>
									<div className="d-flex gap-8">
										{Array(3)
											.fill()
											.map((__, j) => (
												<Skeleton
													key={j}
													height={40}
													width={90}
													style={{ borderRadius: 8 }}
												/>
											))}
									</div>
								</div>
							</div>
						))}
				</div>
			</div>
		</SkeletonTheme>
	),

	MyWalletPage: () => (
		<SkeletonTheme>
			<div>
				<div className="container" style={NAV_SPACE}>
					{/* Balance card */}
					<Skeleton
						height={160}
						style={{ borderRadius: 16, marginBottom: 32 }}
					/>
					{/* Packages title */}
					<Skeleton height={24} width={180} style={{ marginBottom: 16 }} />
					<Row className="mb-4">
						{Array(3)
							.fill()
							.map((_, i) => (
								<Col key={i} md={4} sm={6} className="mb-3">
									<Skeleton height={100} style={{ borderRadius: 12 }} />
								</Col>
							))}
					</Row>
					{/* Transactions title */}
					<Skeleton height={24} width={180} style={{ marginBottom: 16 }} />
					{Array(4)
						.fill()
						.map((_, i) => (
							<div
								key={i}
								className="d-flex justify-content-between mb-2"
								style={{
									background: "#141920",
									borderRadius: 10,
									padding: "12px 16px",
								}}>
								<div>
									<Skeleton
										height={18}
										width={160}
										style={{ marginBottom: 4 }}
									/>
									<Skeleton height={14} width={100} />
								</div>
								<Skeleton height={22} width={70} />
							</div>
						))}
				</div>
			</div>
		</SkeletonTheme>
	),

	ProfilePage: () => (
		<SkeletonTheme>
			<div>
				<div className="container" style={NAV_SPACE}>
					{/* Avatar + name */}
					<div className="d-flex align-items-center gap-8 mb-4">
						<Skeleton circle height={80} width={80} />
						<div>
							<Skeleton height={22} width={160} style={{ marginBottom: 6 }} />
							<Skeleton height={16} width={120} />
						</div>
					</div>
					{/* Form fields */}
					{Array(4)
						.fill()
						.map((_, i) => (
							<div key={i} className="mb-3">
								<Skeleton height={14} width={100} style={{ marginBottom: 6 }} />
								<Skeleton height={48} style={{ borderRadius: 10 }} />
							</div>
						))}
					<Skeleton
						height={48}
						width={160}
						style={{ borderRadius: 10, marginTop: 8 }}
					/>
				</div>
			</div>
		</SkeletonTheme>
	),

	StaticPage: () => (
		<SkeletonTheme>
			<div>
				<div className="container" style={NAV_SPACE}>
					{/* Badge + title */}
					<Skeleton
						height={28}
						width={120}
						style={{ borderRadius: 20, marginBottom: 16 }}
					/>
					<Skeleton height={42} width="60%" style={{ marginBottom: 12 }} />
					<Skeleton height={18} width="80%" style={{ marginBottom: 4 }} />
					<Skeleton height={18} width="65%" style={{ marginBottom: 40 }} />
					{/* Content sections */}
					{Array(3)
						.fill()
						.map((_, i) => (
							<div
								key={i}
								className="mb-4"
								style={{
									background: "#141920",
									borderRadius: 12,
									padding: 24,
								}}>
								<Skeleton
									height={24}
									width="40%"
									style={{ marginBottom: 12 }}
								/>
								<Skeleton
									height={16}
									width="100%"
									style={{ marginBottom: 6 }}
								/>
								<Skeleton height={16} width="90%" style={{ marginBottom: 6 }} />
								<Skeleton height={16} width="75%" />
							</div>
						))}
				</div>
			</div>
		</SkeletonTheme>
	),
};

export default SkeletonComponent;
